import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { PluginState } from './main';

export const conflictResolutionPluginKey = new PluginKey<PluginState>(
	'conflictResolutionPluginKey',
);
